import React, { useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { replaceOnlyNumber } from "common/utils";
import * as authActions from "store/auth/actions";
// import Header from "components/header/Header";
import Header from "components/_newComponents/Header/Header";
import HeroSection from "components/_newComponents/Banner/HeroSection";
import WhyChooseSection from "components/_newComponents/WhyChooseSection/WhyChooseSection";
import HealthcarePlansSection from "components/_newComponents/HealthSection/HealthcarePlansSection";
import HeroContentSection from "components/_newComponents/HeroSection/HeroSection";
import WhoWeAreSection from "components/_newComponents/WhoWeAreSection/WhoWeAreSection";
import Footer from "components/_newComponents/Footer/Footer";
import FAQSection from "components/_newComponents/Faq/FAQSection";
// import CardExplainContainer from "components/cardExplainContainer/CardExplainContainer";
// import BenefitsContainer from "components/benefitsContainer/BenefitsContainer";
// import MedicalAppointments from "components/medicalAppointmentsContainer/medicalAppointmentsContainer";
// import OursPackagesContainer from "components/oursPackagesContainer/oursPackagesContainer";
// import SaveMoneyContainer from "components/saveMoneyContainer/saveMoneyContainer";
// import AdvantagesContainer from "components/advantagesContainer/advantagesContainer";
// import PartnersContainer from "components/partnersContainer/partnersContainer";
// import HowItWorksContainer from "components/howItWorksContainer/howItWorksContainer";
// import DifferentialsContainer from "components/differentialsContainer/differentialsContainer";
// import ContactContainer from "components/contactContainer/contactContainer";
import * as packagesActions from "store/packages/actions";


export const Home = ({ authRequest, verifyTokenRequest, auth_token, vendorsRequest, tradingsRequest }) => {
  const isFirstRender = useRef(true);
  const { search } = useLocation();

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;

      // vendorsRequest()

      if (search) {
        let vendor = replaceOnlyNumber(search);
        if (vendor) {
          tradingsRequest(vendor)
        }
      }

      if (auth_token) {
        verifyTokenRequest();
      } else {
        authRequest();
      }
    }
  }, [authRequest, auth_token, verifyTokenRequest, vendorsRequest, tradingsRequest, search]);

  return (
    <>
      <Header />

      <main>
        <HeroSection />
        <HealthcarePlansSection id="nossos-planos" type="scroll" />
        <WhyChooseSection />
        <HeroContentSection />
        <WhoWeAreSection />
        <FAQSection />
        <Footer />
        {/* <CardExplainContainer />
        <BenefitsContainer />
        <MedicalAppointments />
        <AdvantagesContainer />
        <PartnersContainer />
        <SaveMoneyContainer />
        <OursPackagesContainer />
        <HowItWorksContainer />
        <DifferentialsContainer />
        <ContactContainer />
        <Footer /> */}
        <div className="overlay-logo" />
      </main>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    auth_token: state.auth.data?.access_token,
    auth_state: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    vendorsRequest: () => {
      dispatch(packagesActions.vendorsRequest());
    },
    tradingsRequest: (tradingkey) => {
      dispatch(packagesActions.tradingsRequest(tradingkey));
    },
    authRequest: () => {
      dispatch(authActions.authRequest());
    },
    verifyTokenRequest: () => {
      dispatch(authActions.verifyTokenRequest());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);
